import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-mdm-settings',
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PanelComponent, PanelHeaderComponent, TitleComponent, RouterLink, RouterLinkActive, RouterOutlet],
})
export class SettingsComponent {}
